import { combineReducers } from '@reduxjs/toolkit';

import { PreQualificationStep } from 'enums/PreQualificationStep';
import store from 'prequalificationV2/store';
import borrowerReducer from 'prequalificationV2/actions/borrower';
import coBorrowerReducer from 'prequalificationV2/actions/coBorrower';
import prequalificationReducer from 'prequalificationV2/actions/prequalificationPortal';
import stagesReducer, { setPreQualificationStep, setSignInStep } from 'prequalificationV2/actions/stages';
import { SignInStep } from 'prequalificationV2/pages/SignInProcess/signInStep.enums';
import dashboardReducer from 'prequalificationV2/actions/dashboardPortal';

import accountReducer, { AccountActionType, setAccount } from './account';
import applicationReducer from './application';
import coOwnerInfoReducer from './coOwnerInfo';
import dataReducer from './data';
import documentsReducer from './documents';
import incomeReducer from './income';
import loadingReducer, { setLoadingState, LoadingType } from './loading';
import proveErrorInfoReducer from './proveErrorInfo';

const globalReducer = combineReducers({
  data: dataReducer,
  documents: documentsReducer,
  borrower: borrowerReducer,
  coBorrower: coBorrowerReducer,
  income: incomeReducer,
  stages: stagesReducer,
  application: applicationReducer,
  account: accountReducer,
  loading: loadingReducer,
  dashboardPortal: dashboardReducer,
  proveErrorInfo: proveErrorInfoReducer,
  prequalificationPortal: prequalificationReducer,
  coOwnerInfo: coOwnerInfoReducer,
});

export default globalReducer;

export type RootState = ReturnType<typeof globalReducer>;
export type AppDispatch = typeof store.dispatch;

export {
  setPreQualificationStep,
  PreQualificationStep,
  setSignInStep,
  SignInStep,
  AccountActionType,
  setLoadingState,
  LoadingType,
  setAccount,
};
